import React from 'react'
import styled from 'styled-components'
import {Controller, UseFormMethods} from 'react-hook-form'
import {QuesionForm} from 'organization/Obie/Blocks/ProcessForm'
import FormControl from '@material-ui/core/FormControl'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import FormControlLabel from '@material-ui/core/FormControlLabel'

export default function RadioOptions(
  props: QuesionForm & {control: UseFormMethods['control']},
) {
  const {answer, question} = props

  const options = question.options.map((opt, index) => (
    <FormControlLabel
      key={index}
      color="primary"
      value={opt.value}
      control={<Radio />}
      label={opt.value}
    />
  ))
  return (
    <Controller
      name={`answer`}
      defaultValue={answer?.answer}
      control={props.control}
      render={({value, onChange}) => (
        <StyledFormControl component="fieldset">
          <RadioGroup
            aria-label="question-options"
            name={`question-${question.id}-options`}
            value={value}
            onChange={onChange}
          >
            {options}
          </RadioGroup>
        </StyledFormControl>
      )}
    />
  )
}

const StyledFormControl = styled((props) => {
  return <FormControl {...props} />
})`
  color: white;
  & .MuiIconButton-label {
    color: white;
  }
`
